import React from 'react';
import styled from 'styled-components';
import { useNavigate, useLocation } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import { PageContainer } from '../App';

const NotFoundPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state?.message || "We couldn't find the page you're looking for";

  return (
    <PageContainer>
      <NotFoundContainer>
        <ErrorCode>404</ErrorCode>
        <ErrorTitle>Page Not Found</ErrorTitle>
        <ErrorMessage>{message}</ErrorMessage>
        <BackButton onClick={() => navigate('/')}>
          Checkout our home page
        </BackButton>
      </NotFoundContainer>
    </PageContainer>
  );
};

const NotFoundContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  text-align: center;
  padding: 2rem;
`;

const ErrorCode = styled.h1`
  font-size: 8rem;
  font-weight: 900;
  color: #000000;
  margin: 0;
  line-height: 1;
  user-select: none;

  @media (max-width: 768px) {
    font-size: 6rem;
  }
`;

const ErrorTitle = styled.h2`
  font-size: 2rem;
  font-weight: 600;
  color: #292929;
  margin: 1rem 0;

  @media (max-width: 768px) {
    font-size: 1.5rem;
  }
`;

const ErrorMessage = styled.p`
  font-size: 1.2rem;
  color: #757575;
  margin: 0 0 2rem;
  max-width: 500px;
  line-height: 1.5;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const BackButton = styled.button`
  background: #292929;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 99px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #404040;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    font-size: 1rem;
    padding: 0.8rem 1.5rem;
  }
`;

export default NotFoundPage; 